export const HOME = "/"
export const DEBITOS_OCULTADOS = "/debitos-ocultados"
export const BANCOS = "/bancos"
export const DAM = "/dam"
export const ADQUIRENTES = "/adquirentes"

export default {
    HOME,
    DEBITOS_OCULTADOS,
    BANCOS,
    DAM,
    ADQUIRENTES
}